import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5000/api`;

// Додаємо токен авторизації до всіх запитів
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// При 401 — виходимо з системи (крім спроби логіну)
axios.interceptors.response.use(
  response => response,
  error => {
    const isLoginRequest = error.config && error.config.url && error.config.url.includes('/auth/login');
    
    if (error.response && error.response.status === 401 && !isLoginRequest) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export function getUserPlatform() {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return u.platform || '';
  } catch { return ''; }
}

export default API_URL;
